import fetch from "./fetch";
/**
 * 患者列表
 */
const patientListManage = {
  //患者分页
  getPatientCheckList(params) {
    return fetch({
      isLoading: true,
      url: "/patient/page",
      method: "GET",
      params,
    });
  },
  //患者标签筛选分页
  getPatientAdvancedList(params, data) {
    return fetch({
      isLoading: true,
      url: "/patient/advancedPage",
      method: "POST",
      params,
      data,
    });
  },

  //审核详情
  getAuditDetail(params) {
    return fetch({
      isLoading: true,
      url: "/drugDistributionAudit/detail",
      method: "GET",
      params,
    });
  },

  //审核分页
  getAuditPage(params) {
    return fetch({
      isLoading: true,
      url: "/drugDistributionAudit/page",
      method: "GET",
      params,
    });
  },

  //审核
  drugDistributionAudit(data) {
    return fetch({
      isLoading: true,
      url: "/drugDistributionAudit/audit",
      method: "POST",
      data,
    });
  },
};

export default patientListManage;
